// frontend/src/pages/TestFeatureFlags.jsx
// ============================================================================
// PAGE DE TEST FEATURE FLAGS - DÉMONSTRATION INVISIBILITÉ
// ============================================================================

import React from 'react';
import { useFeatureFlag } from '../hooks/useFeatureFlag';
import FeatureGate from '../components/FeatureGate';

function TestFeatureFlags() {
  const { isEnabled, loading, error } = useFeatureFlag('rfid_attendance');
  
  // Récupérer les infos de l'entreprise connectée
  const company = JSON.parse(localStorage.getItem('company') || '{}');
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  return (
    <div style={{ 
      padding: '40px', 
      fontFamily: 'Arial, sans-serif',
      maxWidth: '1200px',
      margin: '0 auto',
      backgroundColor: '#f8f9fa'
    }}>
      
      {/* En-tête */}
      <div style={{ 
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        padding: '30px',
        borderRadius: '12px',
        marginBottom: '30px',
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
      }}>
        <h1 style={{ margin: 0, fontSize: '32px', fontWeight: 'bold' }}>
          🧪 Test Feature Flags
        </h1>
        <p style={{ margin: '10px 0 0 0', opacity: 0.9 }}>
          Déploiement progressif des fonctionnalités
        </p>
      </div>

      {/* Informations de connexion */}
      <div style={{ 
        background: 'white', 
        padding: '25px', 
        borderRadius: '12px',
        marginBottom: '25px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
        border: '1px solid #e0e0e0'
      }}>
        <h2 style={{ 
          margin: '0 0 20px 0',
          fontSize: '20px',
          color: '#333',
          display: 'flex',
          alignItems: 'center',
          gap: '10px'
        }}>
          📊 Informations de connexion
        </h2>
        <div style={{ display: 'grid', gridTemplateColumns: '150px 1fr', gap: '12px' }}>
          <strong style={{ color: '#666' }}>Entreprise :</strong>
          <span>{company.name} <span style={{ 
            background: '#e3f2fd', 
            color: '#1976d2', 
            padding: '2px 8px', 
            borderRadius: '4px',
            fontSize: '12px',
            fontWeight: 'bold'
          }}>ID: {company.id}</span></span>
          
          <strong style={{ color: '#666' }}>Utilisateur :</strong>
          <span>{user.email} <span style={{ 
            background: user.role === 'admin' ? '#fff3e0' : '#f3e5f5', 
            color: user.role === 'admin' ? '#e65100' : '#6a1b9a', 
            padding: '2px 8px', 
            borderRadius: '4px',
            fontSize: '12px',
            fontWeight: 'bold'
          }}>{user.role}</span></span>
        </div>
      </div>

      {/* Statut de la feature */}
      <div style={{ 
        background: 'white', 
        padding: '25px', 
        borderRadius: '12px',
        marginBottom: '25px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
        border: '1px solid #e0e0e0'
      }}>
        <h2 style={{ 
          margin: '0 0 20px 0',
          fontSize: '20px',
          color: '#333',
          display: 'flex',
          alignItems: 'center',
          gap: '10px'
        }}>
          🔍 Statut Feature: <code style={{ 
            background: '#f5f5f5',
            padding: '4px 8px',
            borderRadius: '4px',
            fontFamily: 'monospace',
            fontSize: '16px'
          }}>rfid_attendance</code>
        </h2>
        
        {loading && (
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '15px',
            padding: '20px',
            background: '#f5f5f5',
            borderRadius: '8px'
          }}>
            <div style={{ 
              width: '24px', 
              height: '24px', 
              border: '3px solid #ddd',
              borderTopColor: '#667eea',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite'
            }}></div>
            <span style={{ fontSize: '16px', color: '#666' }}>Vérification en cours...</span>
          </div>
        )}
        
        {error && (
          <div style={{ 
            padding: '20px',
            background: '#ffebee',
            color: '#c62828',
            borderRadius: '8px',
            border: '1px solid #ef9a9a'
          }}>
            ❌ <strong>Erreur:</strong> {error}
          </div>
        )}
        
        {!loading && !error && (
          <div style={{ 
            padding: '25px',
            background: isEnabled ? '#e8f5e9' : '#ffebee',
            borderRadius: '8px',
            border: `2px solid ${isEnabled ? '#4caf50' : '#f44336'}`
          }}>
            <div style={{ 
              fontSize: '48px', 
              fontWeight: 'bold',
              marginBottom: '15px',
              color: isEnabled ? '#2e7d32' : '#c62828'
            }}>
              {isEnabled ? '✅ ACTIVÉE' : '❌ DÉSACTIVÉE'}
            </div>
            
            <p style={{ 
              fontSize: '16px', 
              margin: 0,
              color: isEnabled ? '#2e7d32' : '#c62828'
            }}>
              <strong>Résultat :</strong> {isEnabled ? 
                'Cette entreprise peut voir le pointage RFID' : 
                'Cette entreprise ne peut PAS voir le pointage RFID'
              }
            </p>
          </div>
        )}
      </div>

      {/* Test Affichage Conditionnel */}
      <div style={{ 
        background: 'white', 
        padding: '25px', 
        borderRadius: '12px',
        marginBottom: '25px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
        border: '1px solid #e0e0e0'
      }}>
        <h2 style={{ 
          margin: '0 0 20px 0',
          fontSize: '20px',
          color: '#333',
          display: 'flex',
          alignItems: 'center',
          gap: '10px'
        }}>
          🎯 Test Affichage Conditionnel
        </h2>
        
        <div style={{ 
          background: '#f8f9fa',
          padding: '20px',
          borderRadius: '8px',
          marginBottom: '20px'
        }}>
          <p style={{ 
            margin: '0 0 15px 0',
            fontSize: '14px',
            color: '#666',
            fontStyle: 'italic'
          }}>
            ℹ️ Ce contenu est TOUJOURS visible (pas de feature flag)
          </p>
          
          <button style={{ 
            padding: '12px 24px',
            background: '#667eea',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '16px',
            fontWeight: '600',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
          }}>
            📝 Pointage Manuel
          </button>
          
          {/* CE BOUTON N'APPARAÎT QUE SI LA FEATURE EST ACTIVÉE */}
          <FeatureGate feature="rfid_attendance">
            <button style={{ 
              padding: '12px 24px',
              background: '#4caf50',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '16px',
              fontWeight: '600',
              marginLeft: '15px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              animation: 'fadeIn 0.5s ease-in'
            }}>
              🎫 Pointage par Badge RFID
            </button>
          </FeatureGate>
        </div>

        {/* Bloc explicatif qui change selon le statut */}
        {isEnabled ? (
          <div style={{ 
            padding: '20px',
            background: '#e8f5e9',
            borderRadius: '8px',
            border: '2px solid #4caf50'
          }}>
            <p style={{ 
              margin: 0,
              fontSize: '15px',
              color: '#2e7d32',
              fontWeight: '500'
            }}>
              ✅ Vous devriez voir <strong>DEUX boutons</strong> ci-dessus :
              <br />
              • "📝 Pointage Manuel" (toujours visible)
              <br />
              • "🎫 Pointage par Badge RFID" (visible car feature activée)
            </p>
          </div>
        ) : (
          <div style={{ 
            padding: '20px',
            background: '#fff3e0',
            borderRadius: '8px',
            border: '2px solid #ff9800'
          }}>
            <p style={{ 
              margin: 0,
              fontSize: '15px',
              color: '#e65100',
              fontWeight: '500'
            }}>
              ℹ️ Vous ne devriez voir qu'<strong>UN SEUL bouton</strong> ci-dessus :
              <br />
              • "📝 Pointage Manuel" (toujours visible)
              <br />
              <br />
              Le bouton "🎫 Pointage par Badge RFID" est <strong>complètement invisible</strong> car la feature est désactivée pour votre entreprise.
            </p>
          </div>
        )}
      </div>

      {/* Simulation complète */}
      <div style={{ 
        background: 'white', 
        padding: '25px', 
        borderRadius: '12px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
        border: '1px solid #e0e0e0'
      }}>
        <h2 style={{ 
          margin: '0 0 20px 0',
          fontSize: '20px',
          color: '#333',
          display: 'flex',
          alignItems: 'center',
          gap: '10px'
        }}>
          📝 Instructions de test
        </h2>
        
        <div style={{ 
          background: '#f8f9fa',
          padding: '20px',
          borderRadius: '8px'
        }}>
          <ol style={{ margin: 0, paddingLeft: '20px', lineHeight: '1.8' }}>
            <li>
              <strong>Company {company.id === 23 ? '23 (VOUS)' : 'X'}:</strong> {company.id === 23 ? 
                'Devrait voir le bloc vert avec le bouton RFID' : 
                'Si c\'est company 23, devrait voir le bouton RFID'
              }
            </li>
            <li>
              <strong>Autre company:</strong> Ne devrait voir que le bouton manuel, rien d'autre
            </li>
            <li>
              <strong>Invisibilité totale:</strong> Pas de message "non disponible", pas d'espace vide, juste... rien !
            </li>
            <li>
              Vérifiez bien que l'ID de votre company ({company.id}) est affiché en haut
            </li>
          </ol>
        </div>

        <div style={{ 
          marginTop: '20px',
          padding: '15px',
          background: '#e3f2fd',
          borderRadius: '8px',
          borderLeft: '4px solid #2196f3'
        }}>
          <strong style={{ color: '#1565c0' }}>💡 Conseil :</strong>
          <p style={{ margin: '8px 0 0 0', color: '#1976d2' }}>
            Testez avec plusieurs comptes de différentes entreprises pour voir la différence !
          </p>
        </div>
      </div>

      {/* Styles pour l'animation */}
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        
        @keyframes fadeIn {
          from { 
            opacity: 0;
            transform: translateX(-10px);
          }
          to { 
            opacity: 1;
            transform: translateX(0);
          }
        }
      `}</style>
    </div>
  );
}

export default TestFeatureFlags;